import { withStyles } from "@material-ui/core/styles";
import BellIcon from "@material-ui/icons/Notifications";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setErrorMessage } from "../../store/actionCreators/errorMessage";
import posed from "react-pose";

import {
  Button,
  Badge,
  Hidden,
  withWidth,
  Typography
} from "@material-ui/core";
import { GENERIC_FEEDBACK, BASE_URL } from "../../utils/Urls";
import PostJSON from "../../utils/PostJSON";
import FeedbackIframe from "./FeedbackIframe";
import FeedbackList from "./FeedbackList";
import FeedbackIntro from "../Utils/FeedbackIntro";
import IframeContainer from "../Dashboard/FoodDetails";

const COMMON_STYLES = {
  speechBubble: {
    width: "200px",
    height: "50px",
    textAlign: "center",
    position: "relative",
    backgroundColor: "#fffee5",
    border: "4px solid #fffee5",
    "-webkit-border-radius": "10px",
    "-moz-border-radius": "10px",
    borderRadius: "6px",
    "-webkit-box-shadow": "2px 2px 4px #888",
    "-moz-box-shadow": "2px 2px 4px #888",
    boxShadow: "2px 2px 4px #888"
  },
  speechBubbleBefore: {
    content: "no-open-quote",
    position: "absolute",
    width: 0,
    height: 0,
    border: "10px solid",
    borderColor: "#fffee5 transparent transparent #fffee5"
  }
};

const styles = theme => ({
  root: {
    maxWidth: "450px",
    width: "100%",
    height: "100%",
    maxHeight: "400px",
    borderRadius: "10px",
    position: "relative"
  },
  fab: {
    backgroundColor: "#F37020",
    "&:hover": {
      backgroundColor: "#F37020",
      opacity: "0.9"
    }
  },
  fabPosition: {
    position: "fixed",
    bottom: "75px",
    right: "75px"
  },
  fixedBadgeBackground: {
    top: "-5px",
    right: "0px",
    fontWeight: "bold",
    backgroundColor: "white"
  },
  normalBadgeBackground: {
    backgroundColor: "white",
    width: "10px",
    height: "10px",
    border: "1px solid #F37020",
    top: "0px",
    right: "0px"
  },
  Bell: {
    animation: "ring 4s .7s ease-in-out infinite",
    transformOrigin: "50% 4px"
  },
  speechBubble: {
    bottom: "0px",
    right: "200px",
    ...COMMON_STYLES.speechBubble,
    "&:before": {
      left: "191px",
      bottom: "29px",
      transform: "rotate(-14deg)",
      ...COMMON_STYLES.speechBubbleBefore
    }
  },
  speechBubbleMobile: {
    top: "60px",
    right: "90px",
    ...COMMON_STYLES.speechBubble,
    "&:before": {
      left: "160px",
      bottom: "45px",
      transform: "rotate(180deg)",
      ...COMMON_STYLES.speechBubbleBefore
    }
  }
});

const fullScreenValid = ["xs", "sm"];

const renderSpeechBubble = (className, funcPointer) => {
  return (
    <div style={{ position: "absolute" }} onClick={funcPointer}>
      <Typography className={className}>
        Hi, you have received a message
      </Typography>
    </div>
  );
};

class FeedbackIndicator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackData: [],
      userInteractionData: [],
      feedbackDialogState: false,
      notificationDialogState: false,
      notifications: {},
      currentNotificationDetails: {},
      introDialogState: false,
      feedbackState: false,
      formData: {},
      skip: true,
      itemInfo: [],
      isBellClicked: false,
      openIframeContainer: false
    };
  }

  componentDidMount() {
    this.fetchUserActions();
  }

  fetchUserActions = () => {
    const currentFoodCourt =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    PostJSON(
      BASE_URL + GENERIC_FEEDBACK,
      {
        foodcourtid: currentFoodCourt.value,
        action: [
          "pending_feedbacks",
          "pending_customerinteractions",
          "pending_notifications"
        ]
      },
      response => {
        const extras = response.extras || {};
        let feedbackData =
          (extras.pending_feedbacks || {}).pending_feedbacks || [];
        feedbackData = feedbackData.map(item => {
          // let key = Object.keys(item);
          // let obj = { ...item[key] };
          let obj = { ...item };
          obj.displayText = {
            title: obj["restaurantname"],
            subTitle: obj["timestamp"]
          };
          return obj;
        });
        let userInteractionData =
          (extras.pending_customerinteractions || {})
            .pending_customerinteractions || [];
        userInteractionData = Object.keys(userInteractionData).map(item => {
          let obj = userInteractionData[item];
          obj.orderid = item;
          obj.displayText = {
            title: obj["title"],
            subTitle: obj["message"]
          };
          return obj;
        });
        // ---------- for offers -------------
        let notifications =
          (extras.pending_notifications || {}).pending_notifications || {};
        // -----------------------------------

        // let introDialogState = extras.auto_open || false;
        // if (introDialogState && feedbackData.length === 0) {
        //   introDialogState = false;
        // }
        if (feedbackData.length !== 0 && feedbackData.length === 1) {
          let orderData = (feedbackData[0] || {}).fooditems || {};
          let orderItems = Object.keys(orderData);
          if (orderItems.length > 3) {
            let [a, b, c, ...d] = orderItems;
            orderItems = [a, b, c + "..."];
          }
          this.setState({ itemInfo: orderItems });
        }
        this.setState({
          userInteractionData,
          feedbackData,
          skip: extras.skip || true,
          introDialogState: feedbackData.length !== 0,
          notifications
        });
        // if (
        //   userInteractionData.length > 0 ||
        //   Object.keys(notifications).length > 0
        // ) {
        //   setTimeout(() => {
        //     this.setState({ closeBubbleText: true });
        //   }, 7000);
        // }
      },
      error => {
        this.props.setErrorMessage((error.extras || {}).message);
      }
    );
  };

  toggleIntroDialog = ({ state, open }) => {
    if (open === false) {
      this.increaseSkipCounter();
    }
    const { feedbackData } = this.state;
    this.setState(
      {
        introDialogState: state,
        feedbackDialogState: open
      },
      () => {
        if (open) {
          if (feedbackData.length === 1) {
            this.closeDialog({ data: feedbackData[0] });
          }
        }
      }
    );
  };

  closeDialog = ({ data, clickedSkip, index }) => {
    const {
      feedbackDialogState,
      notificationDialogState,
      userInteractionData
    } = this.state;
    if (feedbackDialogState && clickedSkip === true) {
      this.increaseSkipCounter();
    }
    const currentFoodCourt =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    if (data !== undefined && feedbackDialogState) {
      this.setState({
        feedbackState: true,
        formData: { foodname: "Feedback", url: data.url, data }
      });
    } else if (data !== undefined && notificationDialogState) {
      PostJSON(
        BASE_URL + GENERIC_FEEDBACK,
        {
          foodcourtid: currentFoodCourt.value,
          action: "interaction_made",
          orderid: data.orderid
        },
        response => {},
        error => {}
      );
      this.setState({
        feedbackState: true,
        formData: {
          foodname: "Notifications",
          url: data.interaction_url,
          data: data
        }
      });

      let newUserInteractionData = JSON.parse(
        JSON.stringify(userInteractionData)
      );
      newUserInteractionData.splice(index, 1);
      this.setState({ userInteractionData: newUserInteractionData });
    }
    this.setState({
      feedbackDialogState: false,
      notificationDialogState: false
    });
  };

  toggleFeedback = state => {
    this.setState({ feedbackState: state, formData: {} });
    if (state === false) {
      this.setState({ feedbackData: [] });
      // setTimeout(() => {
      //   this.fetchUserActions();
      // }, 3000);
    }
  };

  increaseSkipCounter = () => {
    const currentFoodCourt =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    PostJSON(
      BASE_URL + GENERIC_FEEDBACK,
      {
        foodcourtid: currentFoodCourt.value,
        action: "increment_skip_count"
      },
      response => {},
      error => {}
    );
  };

  // api call to clear a specific/viewed notification
  clearSpecificNotification = (currentNotificationDetails = {}) => {
    if (Object.keys(currentNotificationDetails).length === 0) return;
    const currentFoodCourt =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};

    let params = {
      action: "notifications_seen",
      notificationid: Object.keys(currentNotificationDetails)[0] || "", // take the id from the current notification in state
      foodcourtid: currentFoodCourt.value || ""
    };

    PostJSON(
      BASE_URL + GENERIC_FEEDBACK,
      params,
      response => {
        console.log("TCL: clearSpecificNotification -> response", response);
      },
      error => {
        console.log("TCL: clearSpecificNotification -> error", error);
        // don't clear the notification from notification object
        // and do not set it in the state :P
      }
    );
  };

  // will be sent as a prop to iframe container
  notificationIframeHandler = () => {
    // take the current notification detail
    // clear it from the notifications object in state,
    // close the iframe container
    const { currentNotificationDetails } = this.state;
    let newNotificationData = { ...this.state.notifications };
    delete newNotificationData[currentNotificationDetails.notificationid];
    this.setState({
      notifications: newNotificationData,
      openIframeContainer: false
    });
  };

  // will be sent as a prop to FeedbackList for onclose
  handleNotification = (notificationData = {}) => event => {
    // make an api call to clear the current notification in the background
    // close the current popup,
    // open the iframe container
    let notificationid = Object.keys(notificationData)[0];
    let currentNotificationDetails = {
      notificationid: Object.keys(notificationData)[0],
      ...notificationData[notificationid]
    };
    this.setState({
      currentNotificationDetails,
      feedbackDialogState: false,
      notificationDialogState: false,
      openIframeContainer: true
    });
    this.clearSpecificNotification(notificationData);
  };

  openNotificationDialog = () => {
    this.setState({
      notificationDialogState: true,
      isBellClicked: true
    });
  };

  render() {
    const { classes, width, isMobile = true } = this.props;
    const {
      root,
      fab,
      fixedBadgeBackground,
      normalBadgeBackground,
      fabPosition,
      Bell,
      speechBubble,
      speechBubbleMobile
    } = classes;
    const {
      userInteractionData,
      feedbackData,
      feedbackDialogState,
      notificationDialogState,
      introDialogState,
      feedbackState,
      formData,
      skip,
      itemInfo,
      isBellClicked,
      openIframeContainer,
      currentNotificationDetails,
      closeBubbleText,
      notifications
    } = this.state;
    let actionsLeft =
      userInteractionData.length || Object.keys(notifications).length;
    let fullScreen = false;
    if (fullScreenValid.includes(width)) {
      fullScreen = true;
    }

    return (
      <Fragment>
        <Hidden only={["md", "lg", "xl"]}>
          {isMobile && (
            <Fragment>
              <BellIcon
                className={actionsLeft !== 0 && !isBellClicked ? Bell : ""}
                style={{ color: "white" }}
                onClick={this.openNotificationDialog}
              />

              {actionsLeft !== 0 && !isBellClicked && !closeBubbleText
                ? renderSpeechBubble(
                    speechBubbleMobile,
                    this.openNotificationDialog
                  )
                : null}
            </Fragment>
          )}
        </Hidden>
        <Hidden only={["xs", "sm"]}>
          <div className={fabPosition}>
            <Button
              variant="fab"
              aria-label="feedbacks left"
              className={fab}
              onClick={this.openNotificationDialog}
            >
              <BellIcon
                className={actionsLeft !== 0 && !isBellClicked ? Bell : ""}
                style={{ color: "white" }}
              />
            </Button>
            {actionsLeft !== 0 && !isBellClicked && !closeBubbleText
              ? renderSpeechBubble(speechBubble, this.openNotificationDialog)
              : null}
          </div>
        </Hidden>
        {(feedbackDialogState || notificationDialogState) && (
          <FeedbackList
            title={
              feedbackDialogState ? "We value your feedback" : "Notifications"
            }
            showIcon={feedbackDialogState ? true : false}
            showReplyIcon={!feedbackDialogState ? true : false} // if notifications(feedbackstate is false), then show
            data={feedbackDialogState ? feedbackData : userInteractionData}
            open={feedbackDialogState || notificationDialogState}
            skip={skip}
            handleClose={this.closeDialog}
            notifications={this.state.notifications}
            handleNotificationClick={this.handleNotification}
            isMobile={isMobile}
          />
        )}
        {feedbackState && (
          <FeedbackIframe
            formData={formData}
            feedbackState={feedbackState}
            toggleFeedback={this.toggleFeedback}
          />
        )}
        {!isMobile && (
          <FeedbackIntro
            open={introDialogState}
            skip={skip}
            handleClose={this.toggleIntroDialog}
            itemInfo={itemInfo}
          />
        )}
        {openIframeContainer && (
          <React.Fragment>
            <Hidden mdDown>
              <IframeContainer
                open={openIframeContainer}
                details={{
                  url: (
                    currentNotificationDetails.interaction_url || ""
                  ).trim(),
                  foodname: currentNotificationDetails.title || "" // title of the iframe container
                }}
                handleClose={this.notificationIframeHandler}
              />
            </Hidden>
            <Hidden mdUp>
              <IframeContainer
                open={openIframeContainer}
                details={{
                  url: (
                    currentNotificationDetails.interaction_url || ""
                  ).trim(),
                  foodname: currentNotificationDetails.title || "" // title of the iframe container
                }}
                handleClose={this.notificationIframeHandler}
                fullScreen
              />
            </Hidden>
          </React.Fragment>
        )}
      </Fragment>
    );
  }
}

const mapPropsToState = state => {
  return {};
};

const mapPropsToDispatch = dispatch => {
  return {
    setErrorMessage: errorMessage => {
      dispatch(setErrorMessage(errorMessage));
    }
  };
};

export default connect(
  mapPropsToState,
  mapPropsToDispatch
)(withWidth()(withStyles(styles)(FeedbackIndicator)));



// WEBPACK FOOTER //
// ./src/components/Dashboard/FeedbackIndicator.js